import React, { useEffect, useState } from 'react'
import { CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import useStyles from "./styles"
import Lang from "../../Lang"
import sampleFeeds from '../../utils/sampleFeeds';
import cleanText from '../../utils/cleanText';
import { fetchFeed } from '../../api';

function Getxt() {

    const classes = useStyles()
    const posts = useSelector((state) => state.posts)
    const [text, setText] = useState("")
    const [arrOrigen, setArrOrigen] = useState("")

    const getText = async (u) => {
        let feed = await fetchFeed(u)
        const randomEntry = Math.floor(Math.random() * feed.data.items.length)
        setText(cleanText(feed.data.items[randomEntry].title))
    }

    useEffect(() => {
        const selectedPosts = posts?.popularPosts ? posts.popularPosts : sampleFeeds
        const randomIndex = Math.floor(Math.random() * selectedPosts.length)
        const randomFeed = selectedPosts[randomIndex]
        getText(randomFeed.value)
        setArrOrigen(randomFeed.title)
    }, [])

    return (

        <div>
            <span className={classes.populares}><Lang props={"Origen: "} />{arrOrigen} </span><br />
            <span className={classes.noticia_aleatoria}>{text ? text : <CircularProgress />} </span>
        </div>

    )
}

export default Getxt
